import { Component, computed, inject } from '@angular/core';
import { AuthenticationService } from '../authentication/authentication.service';
import { hasRole, Role } from '../shared/enums/role';
import { PageWithNavigationComponent } from '../shared/page-templates/page-with-navigation/page-with-navigation.component';
import { AccountSubscriptionComponent } from './subscription/subscription.component';
import { ProfileComponent } from './profile/profile.component';
import { BalanceComponent } from './balance/balance.component';
import { SharedBillingComponent } from './shared-billing/shared-billing.component';

@Component({
    selector: 'app-account',
    imports: [
        PageWithNavigationComponent,
        AccountSubscriptionComponent,
        ProfileComponent, BalanceComponent,
        SharedBillingComponent
    ],
    templateUrl: './account.component.html',
})
export class AccountComponent {

  private authenticationService = inject(AuthenticationService);

  protected readonly isSharedBillingMember = computed(() =>
    hasRole(this.authenticationService.currentUserRoles(), Role.SharedBillingMember));

  protected readonly showSubscription = computed(() =>
    !this.isSharedBillingMember() || hasRole(this.authenticationService.currentUserRoles(), Role.ProTier));

}
